var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#259DF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 23.445c-1.275.567-2.62.921-4.038 1.134 1.417-.85 2.55-2.196 3.046-3.825-1.346.779-2.833 1.345-4.462 1.7a7.06 7.06 0 0 0-5.1-2.196c-3.825 0-6.942 3.117-6.942 6.942 0 .566.071 1.062.213 1.558-5.738-.284-10.909-3.046-14.38-7.296-.566 1.063-.92 2.196-.92 3.47a6.937 6.937 0 0 0 3.116 5.81 8.195 8.195 0 0 1-3.187-.85v.07c0 3.4 2.408 6.233 5.596 6.87a7.72 7.72 0 0 1-1.842.213c-.425 0-.92-.07-1.346-.141.921 2.762 3.471 4.816 6.517 4.816-2.408 1.842-5.384 2.975-8.642 2.975-.567 0-1.133 0-1.629-.07a19.711 19.711 0 0 0 10.696 3.116c12.82 0 19.833-10.625 19.833-19.833v-.921A12.72 12.72 0 0 0 50 23.445"
  })));
};
export default SvgTwitterinline;